import React from "react";
import TableHeader from "./components/TableHeader";
import ListTable from "../../components/Table";
import { useSelector } from "react-redux";
import moment from "moment";
import Action from "../../components/Action";
import ShowModal from "../../components/Modal/ShowModal";
import Widget from "../../components/Widget/index.js";
import EditSMSSetting from "./components/EditSMSSetting.js";
import { dateFormate } from "../../utils/commonFunction.js";

const Index = () => {
  const { language } = useSelector((state) => state.Language);
  const renderActions = (record) => {
    return (
      <div className="flex flex-col">
        <ShowModal
          buttonName="Edit"
          modalName="Edit_smsSetting_Temp"
          record={record}
        />
      </div>
    );
  };

  const columns = [
    {
      title: language["user_id"],
      render: (record) => <span>{record.smsId}</span>,
      key: "userId",
    },
    {
      title: language["smsSetting_smsSetting_type"],
      render: (record) => <span className="capitalize">{record.smsType}</span>,
      key: "fullName",
    },
    {
      title: language["smsSetting_description"],
      render: (record) => <p>{record.description}</p>,
      key: "description",
    },
    {
      title: language["smsSetting_createdAt"],
      render: (record) => (
        <span>{dateFormate(record.createdAt)}</span>
      ),
      key: "createdAt",
    },
    {
      title: "",
      render: (record) => <Action>{renderActions(record)}</Action>,
      key: "actions",
      width: "50px",
    },
  ];
  return (
    <Widget>
      <TableHeader />
      <ListTable
        apiName="getSmsSetting"
        recordName="smsSettingList"
        columns={columns}
      />
      <EditSMSSetting />
    </Widget>
  );
};

export default Index;
